export default {
  namespaced: true,
  state: {
    loading: true,
    pagination: {
      current: null,
      total: null,
      data: [],
    },
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
      state.loading = false;
    },
    SET_LOADING: (state, value) => {
      state.loading = value;
    },
    SET_PAGINATION: (state, data) => {
      state.pagination = data;
      state.loading = false;
    },
  },
  actions: {
    get: function ({ commit, dispatch, state }, payload = {}) {
      let url = `vendors/${payload.id}/followers`;
      if (payload.limit) {
        url = `${url}?limit=${payload.limit}`;
      }
      if (payload.page) {
        url = `${url}&page=${payload.page}`;
      }
      if (payload.subscribers) {
        url = `${url}&subscribers=${payload.subscribers}`;
      }
      if (!payload.page) {
        commit("SET_LOADING", true);
      }

      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              }
              commit("SET_LOADING", false);
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            commit("SET_LOADING", false);
            return resolve();
          });
      });
    },
    followVendor: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`user/follow/create`, payload)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    unfollowVendor: function ({ dispatch }, payload = {}) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`user/follow/${payload.id}`)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
  },
};
